/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Spinner, Stack } from '@shopify/polaris';
import PrivateRoute from './components/autoketing-common/PrivateRoute';

import ResourceDataPickerProduct from './components/ResourcePicker/ResourceDataPickerProduct';
import ResourceDataPickerCollection from './components/ResourcePicker/ResourceDataPickerCollection';
import ResourceDataPickerArticle from './components/ResourcePicker/ResourceDataPickerArticle';

const TheContent = lazy(() => import('./components/containers/TheLayout'));
const Login = lazy(() => import('./components/pages/login/Login'));
// log
export default function App() {
  return (
    <main>
      <Router>
        <Suspense
          fallback={
            <Stack distribution='center'>
              <Spinner accessibilityLabel='Small spinner example' size='small' color='teal' />
            </Stack>
          }
        >
          <Switch>
            <Route exact path='/login' component={Login} />
            <PrivateRoute path='/' component={TheContent} />
          </Switch>
          <ResourceDataPickerProduct />
          <ResourceDataPickerCollection />
          <ResourceDataPickerArticle />
        </Suspense>
      </Router>
    </main>
  );
}
// getShopInfo
